module.exports = {"title":"Recebemos sua contestação","protocol":"12340298091284091284","text":"Em breve, a gente vai entrar em contato com você. Enquanto isso, guarde o número do protocolo:","used":" 21/10/2017","hour":" 16:30","confirmButtonLabel":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ContestationConfirm/data.json
// module id = 1839
// module chunks = 0